import React from 'react';
import './css/master.scss';
import './css/my-account.scss';
import './css/merge-app.scss';
import { useAuth } from '../../../contexts/AuthProvider';
import { buildLoginUrl } from '../../../utils/authHelper';
import language from '../../../utils/LanguageSettings';

interface MyAccountWrapperProps {
  children: React.ReactNode;
}

/**
 * Login-guard wrapper for MyAccount pages.
 * Auth is handled at root level by AuthProvider which sets the globals.
 * This component just waits for auth to complete, then redirects to login
 * if the user is not authenticated. Public pages don't need this wrapper.
 */
const MyAccountWrapper: React.FC<MyAccountWrapperProps> = ({ children }) => {
  const { loading, isLoggedIn } = useAuth();

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (!isLoggedIn) {
    // Redirect to NowID login — same behaviour as before
    window.location.href = buildLoginUrl(language);
    return <div className="loading">Redirecting to login...</div>;
  }

  return <>{children}</>;
};

export default MyAccountWrapper;
